import http from '../../../../plugins/http-common'
import { locationEntity } from "../../domain/entities/location_entity";
import { LocationContract } from "../../domain/contracts/location_contract";
import { locationIndexEntity } from '../../domain/entities/location_index_entity';
import i18n from "../../../../i18n"

export const HttpLocationRepository = {
  ...LocationContract,
  model: locationEntity,
  model_index: locationIndexEntity,

  async index(page, per_page, search, fields, sort_by) {
    var sort = ""

    if (sort_by.length > 0) sort = '&sort=' + sort_by[0].field + '&sort_direction=' + sort_by[0].direction;
    const res = await http.get('locations?page=' + page + '&per_page=' + per_page + '&fields=' + fields + (search != "" ? '&search=' + search : "") + sort);
    
    for(let i = 0; i < res.data.data.length; i++) {
      res.data.data[i] = res.data.data[i].attributes;
      res.data.data[i].parameters = res.data.data[i].id;
      
      if(res.data.data[i].ba_id != null) res.data.data[i].id = res.data.data[i].id + "b"

      res.data.data[i].actions = JSON.parse(JSON.stringify([
        {
            name: i18n.t('locations.details'),
            icon: {
                color: 'accent',
                icon: 'info'
            },
            link: (res.data.data[i].bay_id != null) ? 'locations/details/' + res.data.data[i].id + '_bay' : 'locations/details/' + res.data.data[i].id,
            permission: "location.show"
        },
        {
            name: i18n.t('locations.edit'),
            icon: {
                color: 'accent',
                icon: 'edit'
            },
            link: (res.data.data[i].bay_id != null) ? 'locations/edit/' + res.data.data[i].id + '_bay' : 'locations/edit/' + res.data.data[i].id,
            permission: "location.update"
        },
        {
            name: i18n.t('locations.download_labels'),
            icon: {
                color: 'accent',
                icon: 'label'
            },
            method: 'downloadLabels',
            permission: 'location.show'
        },
        {
            name: i18n.t('locations.download_barcode'),
            icon: {
                color: 'accent',
                icon: 'file_download'
            },
            method: 'downloadSingleBarcode',
            permission: 'location.show'
        }
      ]));
    }

    return res;
  },

  async download_barcode(ids) {
    const res = await http.get('locations_download_barcode?ids=' + ids.toString());
    
    return res.data.success.arguments;
  }
};